import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7612 16.5536C34.4187 17.9801 35.6259 19.5818 35.6259 21.7058C35.6259 23.8298 34.4187 25.4315 32.7612 26.858C31.1469 28.2473 28.7818 29.741 25.8472 31.5944L22.9553 33.4208C19.6387 35.5156 16.9856 37.1913 14.8328 38.143C12.6458 39.1098 10.4965 39.5482 8.48438 38.4392C6.47226 37.3302 5.69526 35.2789 5.34484 32.9135C4.9999 30.5852 4.99994 27.4472 5 23.5245V19.8871C4.99994 15.9644 4.9999 12.8265 5.34484 10.4981C5.69527 8.13272 6.47226 6.08141 8.48438 4.97239C10.4965 3.86337 12.6458 4.30182 14.8328 5.26863C16.9856 6.22032 19.6387 7.89602 22.9553 9.99076L25.8471 11.8172C28.7818 13.6706 31.1469 15.1643 32.7612 16.5536Z"
        fill="var(--svg-color-main, white)"
      />
    </svg>
  )
}
